import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    PageSection,
    SectionTitle,
} from 'wanderu-components';

import {
    PARTNER_EMAIL,
    PARTNER_LOGOS,
    PARTNERS_IMAGE,
} from '../../constants';

import aboutUsStyles from '../AboutUs/AboutUs.scss';
import styles from './PartnersSection.scss';

const propTypes = {
    title: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

function PartnersSection(props) {
    const {
        buttonLabel,
        description,
        title,
    } = props;

    return (
        <PageSection
            aria-labelledby="partners-section"
            className={styles.partnersSection}
            layoutClassName={styles.partnersSectionLayout}
        >
            <SectionTitle id="partners-section">
                {title}
            </SectionTitle>
            <span className={styles.partnersDescription}>
                {description}
            </span>
            <A
                className={`${styles.mailButton} ${aboutUsStyles.aboutUsButton}`}
                href={`mailto:${PARTNER_EMAIL}`}
                native
            >
                {buttonLabel}
            </A>
            <img
                alt=""
                className={`${styles.subheader} ${aboutUsStyles.subheaderImage}`}
                src={PARTNERS_IMAGE}
            />
            <div className={styles.logoContainer}>
                {PARTNER_LOGOS.map(({ source }) => (
                    <img
                        alt=""
                        className={styles.partnerLogo}
                        key={source}
                        src={source}
                    />
                ))}
            </div>
        </PageSection>
    );
}

PartnersSection.propTypes = propTypes;

export default PartnersSection;
